"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var reportPeriod_1 = require("../../common/helpers/reportPeriod");
var FranchiseReportsController = /** @class */ (function () {
    function FranchiseReportsController(ReportsModel, UserService) {
        this.ReportsModel = ReportsModel;
        this.reportData = null;
        this.loading = false;
        this.error = '';
        var organisation = UserService.getCurrentUser().organisation;
        this.schools = organisation ? organisation.schools : [];
        this.filters = __assign(__assign({}, (0, reportPeriod_1.defaultReportPeriod)()), { yoy_type: 'same_period', school_ids: [] });
        this.onFilterChange = this.handleFilterChange.bind(this);
        this.fetchData();
    }
    FranchiseReportsController.prototype.handleFilterChange = function (newFilters) {
        this.filters = newFilters;
        this.fetchData();
    };
    FranchiseReportsController.prototype.fetchData = function () {
        var _this = this;
        this.loading = true;
        this.error = '';
        this.ReportsModel.getFranchiseReport(this.filters)
            .then(function (response) {
            _this.reportData = response.data;
            _this.loading = false;
        })
            .catch(function () {
            _this.error = 'Failed to load franchise report data.';
            _this.loading = false;
        });
    };
    return FranchiseReportsController;
}());
FranchiseReportsController.$inject = ['ReportsModel', 'UserService'];
exports.default = FranchiseReportsController;
